import { render, staticRenderFns } from "./SegmentedControl.vue?vue&type=template&id=0ce6baea&scoped=true"
import script from "./SegmentedControl.vue?vue&type=script&lang=js"
export * from "./SegmentedControl.vue?vue&type=script&lang=js"
import style0 from "./SegmentedControl.vue?vue&type=style&index=0&id=0ce6baea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6baea",
  null
  
)

export default component.exports